import DTO from './DTO';

class MedicalExamDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'carrier_registry_number',
        type: String,
        validators: [],
        labelKey: 'Номер разрешения перевозчика (опционально)',
      },
      {
        name: 'carrier_inn',
        type: String,
        validators: [],
        labelKey: 'ИНН Перевозчика',
      },
      {
        name: 'pre_trip_medical_exam_using',
        type: String,
        validators: [],
        labelKey: 'pre_trip_medical_examination',
      },
      {
        name: 'post_trip_medical_exam_using',
        type: String,
        validators: [],
        labelKey: 'post_trip_medical_examination',
      },
      {
        name: 'pre_trip_technical_inspection_using',
        type: String,
        validators: [],
        labelKey: 'pre_techical_inspection',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default MedicalExamDTO;
